import { render } from "./SelectServices.vue?vue&type=template&id=3572794d&scoped=true"
import script from "./SelectServices.vue?vue&type=script&lang=js"
export * from "./SelectServices.vue?vue&type=script&lang=js"

import "./SelectServices.vue?vue&type=style&index=0&id=3572794d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3572794d"]])

export default __exports__